import React from 'react';
import { Avatar, Box, Typography, styled } from '@mui/material';

const ProfileContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2), // Equivalent to Tailwind's gap-4 (4 * 8px = 32px)
}));

const GreetingTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.fontSize * 1.5, // Approximate text-lg
}));

const NameTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.fontSize * 1, // Approximate text-sm
  color: theme.palette.grey[800],
}));

function getTimeBasedGreeting(name = '') {
  const hour = new Date().getHours();

  if (hour >= 5 && hour < 12) {
    return `Good morning,`;
  } else if (hour >= 12 && hour < 17) {
    return `Good afternoon,`;
  } else {
    return `Good evening,`;
  }
}


const ProfileInfo = styled(Box)(({ theme }) => ({}));

const Greeting = ({ name , profilePicture}) => {
  return (
    <ProfileContainer>
      <Avatar src={profilePicture} alt={name} />
      <ProfileInfo>
        <NameTypography>{getTimeBasedGreeting(name)}</NameTypography>
        <GreetingTypography>{name || ""}</GreetingTypography>

      </ProfileInfo>
    </ProfileContainer>
  );
};

export default Greeting;
